<script setup lang="ts">
import { useCurrentUserRole } from "@/api/current-user";
import { useUser } from "@/api/user-query";
import NotFound from "@/components/common/NotFound.vue";
import UserSettings from "@/components/users/UserSettings.vue";
import { useScopeStore } from "@/stores/scope";
import { mdiChevronDoubleLeft } from "@mdi/js";
import { Role } from "@soft-db/monitoring-api-client";
import { Button, Icon } from "@soft-db/ui";

const { t } = useI18n();

const route = useRoute();
const router = useRouter();

const id = computed(() => (route.params.id || "") as string);
const userid = computed(() => (route.params.userid || "") as string);
function goBack() {
	router.push({
		name: "distributor-id-settings",
		params: { id: id.value },
	});
}

const { data: user, error } = useUser(userid);
const { hasRole } = useCurrentUserRole();
const { scope } = useScopeStore();

const rolesAllowed = computed<Role[]>(() => {
	let roles: Role[] = (["viewer", "editor", "admin"] as const).filter((r) => hasRole(r));

	if (scope.type === "distributor" && scope.id === "2" && hasRole("sys_admin")) {
		roles.push("sys_admin");
	}

	return roles;
});
</script>

<template>
	<div>
		<div class="pb-4">
			<Button variant="outline" @click="goBack">
				<Icon :d="mdiChevronDoubleLeft" />
				<span>{{ t("distributor.goBack") }}</span>
			</Button>
		</div>
		<NotFound v-if="error" :page="t('object.user')" />
		<UserSettings
			v-else-if="user"
			:id="userid"
			:user="user"
			:rolesAllowed="rolesAllowed"
			@back="goBack"
		/>
	</div>
</template>
